import {
  WAREHOUSE_STOCK_REQUEST_ALL,
  WAREHOUSE_STOCK_REQUEST_GET,
  WAREHOUSE_STOCK_REQUEST_PUT,
  WAREHOUSE_STOCK_REQUEST_DELETE,
  WAREHOUSE_STOCK_REQUEST_POST,
  WAREHOUSE_STOCK_REQUEST_LOADING,
  WAREHOUSE_STOCK_REQUEST_ERROR,
} from '../../actions/types';

const initialState = {
  warehouseStockRequest: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case WAREHOUSE_STOCK_REQUEST_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WAREHOUSE_STOCK_REQUEST_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WAREHOUSE_STOCK_REQUEST_POST:
      return { isLoading: false, isCompleted: true };
    case WAREHOUSE_STOCK_REQUEST_PUT:
      return { isLoading: false, isCompleted: true };
    case WAREHOUSE_STOCK_REQUEST_DELETE:
      return { isLoading: false, isCompleted: true };
    case WAREHOUSE_STOCK_REQUEST_LOADING:
      return { isLoading: true, isCompleted: true };
    case WAREHOUSE_STOCK_REQUEST_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
